import { mono, sans } from '../ui/atoms.js';
import type { Lang } from '../ui/text.js';

/** The captain checked this guest out, so the seat and its name are someone else's now. */
export function CheckedOut({ lang }: { lang: Lang }) {
  const no = lang === 'no';
  return (
    <main
      className="cc-stars cc-shell"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        padding: 'calc(32px + env(safe-area-inset-top)) 32px calc(32px + env(safe-area-inset-bottom))',
        boxSizing: 'border-box',
        textAlign: 'center',
        background: '#07080c',
        color: '#dfe9f2',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
      }}
    >
      <div style={{ fontFamily: mono, fontSize: 11, letterSpacing: 2, color: '#8fa4b5' }}>SS AURORA</div>
      <h1 style={{ margin: 0, fontFamily: sans, fontSize: 30, fontWeight: 700, letterSpacing: 2 }}>
        {no ? 'DU ER SJEKKET UT' : 'YOU’VE BEEN CHECKED OUT'}
      </h1>
      <p style={{ margin: 0, maxWidth: 320, fontFamily: sans, fontSize: 18, lineHeight: 1.4, color: '#b8c6d2' }}>
        {no
          ? 'Denne plassen er ikke din lenger. Snakk med kapteinen hvis dette er en feil.'
          : 'This seat is no longer yours. Talk to the captain if that’s a mistake.'}
      </p>
    </main>
  );
}
